import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { UserService } from './service/user/user.service';
import {
  RECAPTCHA_SETTINGS,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaModule,
  RecaptchaSettings,
  RecaptchaV3Module,
} from 'ng-recaptcha';
import { HeaderComponent } from './feature/header/header.component';
import { FooterComponent } from './feature/footer/footer.component';
import { RegistrationFormComponent } from './feature/registration-form/registration-form.component';
import { SuccessScreenComponent } from './feature/success-screen/success-screen.component';
import { FeatureModule } from './shared/modules/feature/feature.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogoutComponent } from './feature/logout/logout.component';
import { KaercherFormsModule } from '@kaercher/ng-forms';
import { AccountDeletionSuccessComponent } from './feature/account-deletion-success/account-deletion-success.component';
import {ProductRegistrationComponent} from "./feature/product-registration/product-registration.component";

@NgModule({ declarations: [
        AppComponent,
        FooterComponent,
        HeaderComponent,
        RegistrationFormComponent,
        SuccessScreenComponent,
        LogoutComponent,
        AccountDeletionSuccessComponent,
        ProductRegistrationComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    RecaptchaModule,
    TranslateModule.forRoot({
      fallbackLang: 'en-GB',
      loader: provideTranslateHttpLoader({
        prefix:  environment.translation + '/',
        suffix: '.json'
      })
    }),
    FeatureModule.forRoot({default: 'default'}),
    KaercherFormsModule], providers: [
        HttpClient,
        UserService,
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.recaptcha.siteKey,
                badge: 'inline',
                size: 'invisible',
            } as RecaptchaSettings,
        },
        { provide: APP_BASE_HREF, useValue: '/registration' },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule {}
